module.exports = __webpack_public_path__ + "static/media/home-court-fees.299c78fa.svg";